export default "__VITE_ASSET__0fe74b27__"